import { Identity } from '@schibsted/account-sdk-browser/src/identity';
import { Monetization } from '@schibsted/account-sdk-browser/src/monetization';

import type { PlayerConfigOptions } from '../types/global';

import storage, { AUTH_REDIRECT_KEY } from './paywall/sessionStorage';
import { getSkinUrl } from './helpers/staticUrls';

const defaultOptions: PlayerConfigOptions = {
  site: 'vgtv',
  noFirstAd: false,
  context: 'embed',
  ads: {
    preroll: true,
    longform: true,
    sponsorroll: true,
    bumper: false,
    midroll: false,
    postroll: false,
    pausead: false,
    sectionKeywords: [],
  },
  plugins: {
    mediaSession: true,
    topicSubscriber: true,
  },
  paywallAccess: {
    enabled: false,
    message: {
      utmParameters: {
        source: 'vgtv-video',
        term: '',
        content: '',
        medium: '',
      },
      onRedirect: () => {
        storage.set(AUTH_REDIRECT_KEY, window.location.href);
      },
    },
    usePre: false,
    /**
     * For global events and window attributes of identity and monetization instances
     * @see https://github.com/schibsted/account-sdk-browser/commit/319e750409928b6d22fc98376e542f728f2acfdf
     */
    getSpidIdentityInstance() {
      return new Promise((res) => {
        if (window.schIdentity) {
          res(window.schIdentity);
        } else {
          window.addEventListener('schIdentity:ready', (ev) => {
            res((ev as CustomEvent<{ instance: Identity }>).detail.instance);
          });
        }
      });
    },
    getSpidMonetizationInstance() {
      return new Promise((res) => {
        if (window.schMonetization) {
          res(window.schMonetization);
        } else {
          window.addEventListener('schMonetization:ready', (ev) => {
            res(
              (ev as CustomEvent<{ instance: Monetization }>).detail.instance
            );
          });
        }
      });
    },
  },
};

const defaultConfig = {
  vendor: 'vgtv',
  locale: 'no' as const,
  settings: {
    preview: false,
    jw: {
      advertising: {
        podmessage: '__AD_POD_CURRENT__ av __AD_POD_LENGTH__',
      },
      cast: {},
    },
  },
  recommended: {
    grid: true,
    autoplay: false,
  },
  skin: {
    name: 'vgtv2',
    url: getSkinUrl('vgtv2'),
  },
  pulse: {
    provider: 'vgtv',
  },
};

export { defaultConfig, defaultOptions };
